import initialState from './initialState'
import { deepClone } from '@/services/ObjectFormatter'
import { cloneDeep } from 'lodash'

// IVA: EN BOLETA SE CALCULA SOBRE EL TOTAL
// IVA EN FACTURA, SE CALCULA NETO UNITARIO REDONDEANDO AL PRIMER DECIMAL
// MULTIPLICAS POR CANTIDAD PARA SACAR SUBTOTAL
// SE APLICA DCTO PORCENTUAL REDONDEANDO AL PRIMER DECIMAL // SE APLICA DCTO POR MONTO
// SE SUMAN LOS SUBTOTALES PARA OBTENER EL TOTAL NETO
// EL TOTAL NETO SE MULTIPLICA * 0.19 PARA OBTENER IVA
// SE SUMA TOTAL NETO E IVA PARA OBTENER EL TOTAL DE LA VENTA

/**
 * Replaces current items in state by the given items list
 * @param {*} state
 * @param {*} items
 */
const SET_ITEMS = function(state, items) {
    state.items = items
}

const SET_TOTAL = function(state, total) {
    state.total = total
}

const SET_NETO_AND_IVA = function(state, payload) {
    state.neto = payload.neto
    state.iva = payload.iva
}

/**
 * Push a new item into the cart's item list
 * @param {*} state
 * @param {*} item
 */
const ADD_ITEM = function(state, item) {
    let alreadyInList = false
    const items = state.items.map(itm => {
        if (itm.id == item.id) {
            itm.quantity++
            alreadyInList = true
        }
        return itm
    })
    if (alreadyInList) {
        state.items = deepClone(items)
        return
    }
    state.items.push(item)
}

const SET_GLOBAL_DISCOUNT = function(state, discount) {
    state.globalDiscount = cloneDeep(discount)
}

const SET_ACTIVE_MOBILE_ITEM_ID = function(state, id) {
    state.activeMobileItemId = id
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default {
    SET_ITEMS,
    ADD_ITEM,
    RESET_STATE,
    SET_GLOBAL_DISCOUNT,
    SET_TOTAL,
    SET_NETO_AND_IVA,
    SET_ACTIVE_MOBILE_ITEM_ID,
}
